import { Card, CardContent, CardDescription, CardHeader, CardTitle  } from "../../Components/ResourcesCard";
import { categories } from "../../utils/constants";

const Resources = () => {

  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      <div className="fixed inset-0 pointer-events-none z-0 opacity-[0.02]">
        <div className="absolute top-1/4 right-1/5 transform rotate-12">
          <img 
            src="/lovable-uploads/ce3a989f-59fc-48ff-b279-69a65d3b3766.png" 
            alt="Ignite Watermark" 
            className="w-80 h-80 object-contain"
          />
        </div>
        <div className="absolute bottom-1/3 left-1/6 transform -rotate-12">
          <img 
            src="/lovable-uploads/ce3a989f-59fc-48ff-b279-69a65d3b3766.png" 
            alt="Ignite Watermark" 
            className="w-64 h-64 object-contain"
          />
        </div>
      </div>

      {/* <div className="relative z-10">
        <div className="container mx-auto px-6 py-12"> */}
          {/* <div className="text-center mb-12">
            <div className="flex justify-center items-center gap-4 mb-6">
              <img 
                src="/images/logo.png" 
                alt="Ignite Logo" 
                className="w-16 h-16 object-contain"
              />
              <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
                Resources Center
              </h1>
            </div>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Explore our comprehensive collection of resources, research papers, grants, and funding opportunities. Everything you need to advance your projects and initiatives.
            </p>
          </div> */}

          {/* <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {categories.map((category, index) => (
              <Card key={index} className={`bg-gradient-to-br ${category.color} hover:shadow-card-hover transition-all duration-300 h-full`}>
                <CardHeader className="text-center pb-4">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <category.icon className="h-8 w-8 text-primary" />
                  </div>
                  <CardTitle className="text-xl mb-2">{category.title}</CardTitle>
                  <CardDescription className="text-sm">
                    {category.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="space-y-2">
                    {category.items.map((item, itemIndex) => (
                      <div key={itemIndex} className={`p-3 bg-background/50 rounded-md border border-border/50 ${category.link ? 'cursor-pointer hover:bg-background/70 transition-colors' : ''}`}
                          //  onClick={() => category.link && navigate(category.link)}>
                          onClick={() => category.link && window.open(category.link, '_blank')}>
                        <p className="text-sm text-muted-foreground text-center">{item}</p>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div> */}

          <div className="relative z-10">
        <div className="container mx-auto px-6 py-12">
          <div className="text-center mb-12">
            <div className="flex justify-center items-center gap-4 mb-6">
               <img 
                src="/images/logo.png" 
                alt="Ignite Logo" 
                className="w-16 h-16 object-contain"
              />
           
              <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
                Resources Center
              </h1>
            </div>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Explore our comprehensive collection of resources, research papers, grants, and funding opportunities. Everything you need to advance your projects and initiatives.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {categories.map((category, index) => (
              <Card key={index} className={`bg-gradient-to-br ${category.color} hover:shadow-card-hover transition-all duration-300 h-full`}>
                <CardHeader className="text-center pb-4">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <category.icon className="h-8 w-8 text-primary" />
                  </div>
                  <CardTitle className="text-xl mb-2">{category.title}</CardTitle>
                  <CardDescription className="text-sm">
                    {category.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="space-y-2">
                    {category.items.map((item, itemIndex) => (
                      <div key={itemIndex} className={`p-3 bg-background/50 rounded-md border border-border/50 ${category.link ? 'cursor-pointer hover:bg-background/70 transition-colors' : ''}`}
                           onClick={() => category.link && window.open(category.link, '_blank')}>
                        <p className="text-sm text-muted-foreground text-center">{item}</p>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="text-center mt-16">
            <Card className="bg-gradient-to-r from-primary/5 to-primary/10 border-primary/20 max-w-2xl mx-auto">
              <CardContent className="py-8">
                <div className="flex justify-center mb-4">
                  <img 
                     src="/images/logo.png" 
                    alt="Ignite Logo" 
                    className="w-12 h-12 object-contain"
                  />
                </div>
                <h3 className="text-2xl font-bold text-primary mb-4">Stay Updated</h3>
                <p className="text-muted-foreground mb-4">
                  Our resource library is continuously expanding. Check back regularly for new content, research findings, and funding opportunities.
                </p>
                <p className="text-sm text-muted-foreground">
                  Resources will be updated and populated with relevant content in upcoming releases.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resources;